export const AffTrackSelectTranslationKeys = {
  statisticsAfftrackLabel: 'statistics.afftrack-label',
  statisticsAfftrackLabelTooltip: 'statistics.afftreck-label-tooltip',
  statisticsAfftrackPlaceholder: 'statistics.afftrack-placeholder',
}
